import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Image } from '@mafc/trolly';

import { AppliedVoucher } from 'network/response/ICart';
import VoucherCard from '../VoucherCard';
import { IAvailablePromotions } from '../AvailablePromotions/redux/AvailablePromotions.reducer';
import InfoContainer from 'common/InfoContainer/InfoContainer';
import { IPromo } from 'pages/Checkout/redux/reducer/promo.reducer';
import { voucherCardDataMassaging } from './AvailablePromotionsTabs.helper';
import useAvailablePromotionsTabs from 'pages/Checkout/hooks/useAvailablePromotionsTabs.hook';
import { createMarkup } from 'utils/html.util';
import NoCouponMessage from 'assets/noCouponMessage.png';

const AvailablePromotionsTabs: FC<{
  availablePromotions: IAvailablePromotions;
  appliedPromo: AppliedVoucher | null;
  promoState: IPromo;
}> = ({ availablePromotions, appliedPromo, promoState }) => {
  const { t } = useTranslation();
  const { onVoucherApply, onToggleCard } = useAvailablePromotionsTabs({
    availablePromotions,
    appliedPromo,
  });

  const tab = availablePromotions.tabData.data[0];

  return (
    <Box key={tab.tabTitle}>
      {tab.restrictionMessage && (
        <InfoContainer style={{ marginBottom: '16px' }}>
          <>{tab.restrictionMessage}</>
        </InfoContainer>
      )}

      {tab.noCouponMessage && (
        <>
          <Flex justifyContent="center">
            <Image
              mb={3}
              url={NoCouponMessage}
              name="no-coupon-message"
              height="250px"
              width="auto"
            />
          </Flex>
          {tab.noCouponMessage}
        </>
      )}

      {/* Coupon loop */}
      {tab.coupons.map(coupon => {
        const { isApplied, variant, bottomMessage } = voucherCardDataMassaging({
          coupon,
          appliedPromo,
          promoState,
          t,
        });

        const toggleCardHandler = (cardData: { isExpanded: boolean; voucherCode: string }) => {
          onToggleCard({
            ...cardData,
          });
        };

        return (
          <VoucherCard
            key={coupon.code}
            title={coupon.title}
            description={createMarkup(coupon.description)}
            code={coupon.code}
            expiringIn={coupon.expiringIn}
            termsAndConditions={coupon.termsAndConditions.map(tnc => createMarkup(tnc))}
            isApplicable={coupon.isApplicable}
            usagePerCustomer={coupon.usagePerCustomer}
            redeemedCount={coupon.redeemedCount}
            isApplied={isApplied}
            bottomMessage={bottomMessage}
            imageUrl={coupon.imageUrl}
            variant={variant}
            onVoucherApply={onVoucherApply}
            onToggleCard={toggleCardHandler}
          />
        );
      })}
    </Box>
  );
};

export default AvailablePromotionsTabs;
